const config = {
    url: {
        // 这是你的主后端 API 地址
        api: '//subapi.eoe.ink',  // 生产环境
        // api: '//localhost:10888',  // 本地开发环境
        author: '//space.bilibili.com',
        clip: '//www.bilibili.com/video'
    }
};

export default config;